// globalScript.js

document.addEventListener("DOMContentLoaded", function() {
    // Add CSS for checkmark styling
    var style = document.createElement('style');
    style.innerHTML = `
        .bulletpoint {
            display: inline-block;
            width: 16px; /* Adjust size as needed */
            height: 16px; /* Adjust size as needed */
            background-image: url('https://cdn.shopify.com/s/files/1/0418/0564/3943/files/checkmark-16.png?v=1711556901'); /* URL to your checkmark image */
            background-size: cover;
            vertical-align: middle;
            margin-right: 8px; /* Adjust spacing */
        }
    `;
    document.head.appendChild(style);

    // Add checkmark image to elements with 'bulletpoint' class
    var elements = document.querySelectorAll('.bulletpoint');
    elements.forEach(function(element) {
        element.classList.add('checkmark');
    });
});
